import React, { Fragment, FC, useState } from 'react';
import { Button } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { MutationResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';

import { SharesItem } from 'api';
import { ContentProvider } from 'providers';
import { CustomSVG } from 'components';

import { ShareDialog } from 'features/sharing';

interface IProps extends WithStyles<typeof styles> {
  refetchQueries?: (
    mutationResult: MutationResult,
  ) => Array<{ query: DocumentNode; variables?: object }>;
  onDelete: (cache: DataProxy, result: MutationResult['data']) => void;
  onUpdate: (cache: DataProxy, result: MutationResult['data']) => void;
  existingShares: SharesItem[];
}

const styles = (theme: Theme) =>
  createStyles({
    editButton: {
      width: 140,
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(1),
    },
  });

const EditShare: FC<IProps> = ({ classes, existingShares, refetchQueries, onUpdate, onDelete }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const [existingShare] = existingShares;

  if (!existingShare.content) {
    return null;
  }

  function renderEditDialog() {
    return (
      <ContentProvider value={existingShare}>
        <ShareDialog
          onClose={() => setOpen(false)}
          open={open}
          existingShares={existingShares}
          refetchQueries={refetchQueries}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      </ContentProvider>
    );
  }

  function renderButton() {
    return (
      <Button
        fullWidth
        variant="outlined"
        size="small"
        className={classes.editButton}
        startIcon={<CustomSVG name="pencil" color="disabled" />}
        onClick={() => setOpen(true)}>
        {t('sharing:editShare')}
      </Button>
    );
  }

  return (
    <Fragment>
      {renderButton()}
      {renderEditDialog()}
    </Fragment>
  );
};

export default withStyles(styles)(EditShare);
